import { render } from "./ModalContainer.vue?vue&type=template&id=778fc0a5"
import script from "./ModalContainer.vue?vue&type=script&lang=js"
export * from "./ModalContainer.vue?vue&type=script&lang=js"

import "./ModalContainer.vue?vue&type=style&index=0&id=778fc0a5&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__